export default __webpack_public_path__ + "static/media/santa-maria-14.c98e337d.jpg";